<template>
  <div class="footer-block flex flex-column">
    <div class="content flex flex-1">
      <div class="menu flex justify-between">
        <div class="col">
          <div class="col-title">{{ $t('title-guan-yu-qian-jing') }}</div>
          <div class="col-desc" @click="goToSection('introduction')">{{ $t('gong-si-jian-jie')}}</div>
          <div class="col-desc" @click="goToSection('culture')">{{ $t('qi-ye-wen-hua')}}</div>
<!--          <router-link :to="{path:'/about#development'}" class="col-desc">{{ $t('fa-zhan-li-cheng')}}</router-link>-->
          <div class="col-desc" @click="goToSection('development')">{{ $t('fa-zhan-li-cheng')}}</div>
          <div class="col-desc" @click="goToSection('world')">{{ $t('ye-wu-bu-ju')}}</div>
          <div class="col-desc" @click="goToSection('honor')">{{ $t('zi-zhi-rong-yu')}}</div>
          <div class="col-desc" @click="goToSection('invention')">{{ $t('fa-ming-zhuan-li')}}</div>
        </div>
        <div class="col">
          <div class="col-title">{{ $t('chan-pin-jie-jue-fang-an') }}</div>
          <div class="col-desc" @click="goToPage('/productService/product/lifting/electricPump')">
            {{ $t('ren-gong-ju-sheng') }}
          </div>
          <div class="col-desc" @click="goToPage('/productService/product/support')">{{ $t('pei-tao-fu-jian') }}</div>
          <div class="col-desc" @click="goToPage('/productService/product/energy')">{{ $t('neng-yuan-fang-an') }}</div>
        </div>
        <div class="col">
          <div class="col-title">{{ $t('fu-wu') }}</div>
          <div class="col-desc" @click="goToPage('/productService/service/application')">{{
              $t('ying-yong-fang-an')
            }}
          </div>
          <div class="col-desc" @click="goToPage('/productService/service/service')">{{ $t('fu-wu') }}</div>
        </div>
        <div class="col">
          <div class="col-title">{{ $t('title-ke-chi-xu-fa-zhan') }}</div>
          <div class="col-desc" @click="goToPage('/develop')">{{ $t('title-ke-chi-xu-fa-zhan') }}</div>
        </div>
        <div class="col">
          <div class="col-title">{{ $t('title-xin-wen-zhong-xin') }}</div>
          <div class="col-desc" @click="goToPage('/news')">{{ $t('title-xin-wen-zhong-xin') }}</div>
        </div>
        <div class="col">
          <div class="col-title">{{ $t('lian-xi-wo-men') }}</div>
          <div class="col-desc">
            <div>{{ $t('dian-hua') }}{{ info.contactPhone }}</div>
            <div>{{ $t('you-xiang') }}{{ info.email }}</div>
            <div>{{ $t('wang-zhi') }}{{ info.webUrl }}</div>
            <div>{{ $t('di-zhi') }}{{ info.address }}
            </div>
          </div>
        </div>
    </div>
    </div>
    <div class="bottom-block">
      <div class="text">{{ $t('footer') }}</div>
    </div>
  </div>
</template>

<script>
import {getContactInfo} from "@/api";
import {getFullUrl} from "@/utils/url";
import {EventBus} from "@/utils/eventBus";

export default {
  name: "CommonFooter",
  data() {
    return {
      info: {}
    }
  },
  created() {
    this.fetchContantInfo()
  },
  computed:{
    langZh(){
      return sessionStorage.getItem('lang') === 'zh'
    }
  },
  methods: {
    goToPage(path) {
      this.$router.push(path)
    },
    goToSection(sectionId){
      // 如果当前不在关于页面，先跳转到关于页面
      if (this.$route.path !== '/about') {
        this.$router.push('/about');
        // 等待路由跳转完成后触发滚动
        setTimeout(() => {
          EventBus.$emit('scrollToSection', sectionId);
        }, 300);
      } else {
        // 已经在关于页面，直接触发滚动
        EventBus.$emit('scrollToSection', sectionId);
      }
    },
    fetchContantInfo() {
      getContactInfo().then(res => {
        this.info = res.data[0]
        this.info.imageUrl = getFullUrl(this.info.imageUrl)
      })
    },
  }
}
</script>

<style scoped lang="scss">
.footer-block {
  height: 400px;
  background: #0C1553;
  padding: 56px 10% 17px;
  @media (min-width: 1024px) and (max-width: 1440px){
    height: 360px;
  }
}

@media screen and (max-width: 1024px) {
  .footer-block {
    display: none;
  }
}

.content{
  display: flex;
}
.menu{
width: 100%;
}
.col:last-child{
  max-width: 35%;
}

.col {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  //margin-left: 24px;
  //width: 208px;

  .col-title {
    color: #FFF;
    font-family: "Alibaba PuHuiTi";
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 22px;
    @media (min-width: 1024px) and (max-width: 1440px){
      font-size: 16px;
      margin-bottom: 10px;
    }
  }

  .col-desc {
    color: #999;
    font-family: "Alibaba PuHuiTi";
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; /* 250% */
    cursor: pointer;
    &:hover{
      color: #FFF;
    }
    @media (min-width: 1024px) and (max-width: 1440px){
      font-size: 16px;
      line-height: 32px;
    }
  }
}

.col:first-child {
  margin-left: 0;
}

.bottom-block {
  height: 16px;

  .text {
    text-align: center;
    color: #999;
    font-family: "Alibaba PuHuiTi";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}
</style>
